import { render, staticRenderFns } from "./BaseModalDialog.vue?vue&type=template&id=4b7b1012&"
import script from "./BaseModalDialog.vue?vue&type=script&lang=js&"
export * from "./BaseModalDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports